import { Popover, Overlay } from 'ui'
import { Button } from 'ui'
import React from "react";
import OutsideAlerter from './OutsideAlerter'

function CombineCodesOverlay(props) {
  return (<Overlay placement="bottom"
            show={props.show}
            container={props.container}
            target={props.target}>
              <Popover id="popover">
                <OutsideAlerter onHide={props.onHide}>
                  <div>
                    <div>
                      Want to merge codes?
                    </div>
                    <div style={{textAlign:'right', marginTop:"5px"}}>
                      <Button size="small" onClick={props.onClick} variant="white">Yes</Button>
                    </div>
                  </div>
                </OutsideAlerter>
              </Popover>
          </Overlay>);
}

export default CombineCodesOverlay;
